<template>
  <div class="main-box main-content">
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="100px" label-suffix="：">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item  label="旧密码" prop="password">
              <el-input v-model="temp.password" show-password></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="新密码" prop="passwordnew">
              <el-input v-model="temp.passwordnew" show-password></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="确认新密码">
              <el-input v-model="temp.passwordnew1" show-password></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <xr-button type="primary" @click="save('dataForm')">确定</xr-button>
        <xr-button type="default" @click.native="dialogVisible = false">取消</xr-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

    export default {
        name: "partyBSelect",
        data() {
          return {
            dialogName: '密码修改',
            dialogVisible: false,                                       //弹框
            type: 'save',                                                //类型
            temp:{
            	id :'',
              password: '',                                              //菜单名称
              passwordnew: '',                                              //菜单编码
              passwordnew1: '',


            },
            rules: {
              password: [
                { message: '旧不密码不能为空!', required: true, trigger: 'blur' }
              ],
              passwordnew: [
                { message: '新密码不能为空!', required: true, trigger: 'blur' }
              ],

            }
          }
        },
        components: {

        },
        methods: {
          init(id){
            this.dialogVisible = true;
            this.temp.id = id;
            this.temp.passwordnew = '';
            this.temp.passwordnew1= '';
            this.temp.password = '';
          },
          save(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {

              	if(this.temp.passwordnew == this.temp.passwordnew1){

              		console.log(this.temp);

	                return this.request({
	                  method:'post',
	                  url:'/web/service?method=tCoreUser_checkPassword',
	                  params: this.temp
	                }).then((response) =>{
	                  if (response.code === 0) {
	                    this.$message({
	                      message: '操作成功',
	                      type: 'success',
	                      duration: 1500,
	                      onClose: () => {
	                        this.dialogVisible = false
	                        this.$parent.$refs.areaTree.initDeptTree();
	                        this.$parent.$refs.xrTable.getData();
	                      }
	                    })
	                  } else {
	                    this.$message.error(response.msg)
	                  }
	                })
	              } else {
	                this.$message.error("新密码两次输入的不一样！");
	                return false;
	              }
            	}else {
	                console.log('error submit!!');
	                return false;
	              }
             }
            );
          },
          //重置
          resetTemp() {
            this.temp.passwordnew = '';
            this.temp.passwordnew1 = '';
            this.temp.password = '';
            this.temp.id = '';
            this.$nextTick(() => {      //清空校验
              this.$refs['dataForm'].clearValidate()
            })
          },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/checkPassword.vue